import { render, staticRenderFns } from "./cancellations.vue?vue&type=template&id=1e1c887a&scoped=true&lang=html&"
import script from "./cancellations.vue?vue&type=script&lang=js&"
export * from "./cancellations.vue?vue&type=script&lang=js&"
import style0 from "./cancellations.vue?vue&type=style&index=0&id=1e1c887a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c887a",
  null
  
)

export default component.exports